import { EnumBase } from 'hay-core-react';

const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB',
  'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
];

class ContratoUfEnum extends EnumBase {
  constructor() {
    super(UFS.map((sigla) => `main.contrato.uf.${sigla}`), null);
  }
}

export default new ContratoUfEnum();
